import React from 'react';

import DOMPurify from 'isomorphic-dompurify';

export const ComponentizeString = ({
  htmlString = '',
  classNaming,
}: {
  htmlString: string;
  classNaming?: string;
}) => {
  // Sanitize the HTML string
  const sanitizedHtml = DOMPurify.sanitize(htmlString, {
    USE_PROFILES: { html: true },
    ALLOWED_ATTR: ['class'],
  });

  // Render the sanitized HTML string
  return <div className={classNaming} dangerouslySetInnerHTML={{ __html: sanitizedHtml }} />;
};
